<div class="content-wrapper container-xxl p-0" *ngIf="articleDetails">
  <div class="content-body">

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          {{ 'MENU.DASHBOARD.USER_DETAILS' | translate }}
        </h4>
      </div>

      <div class="card-body">

        <!-- User Info -->
        <div class="row mb-3">
          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.ID' | translate }}:</strong>
            <span class="mr-3">{{ articleDetails.id }}</span>
          </div>

          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.NAME' | translate }}:</strong>
            <span class="mr-3">{{ articleDetails.name }}</span>
          </div>

          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.EMAIL' | translate }}:</strong>
            <span class="mr-3">{{ articleDetails.email }}</span>
          </div>

          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.NOTIFICATIONS' | translate }}:</strong>
            <span  
              class="badge mr-3"
              [ngClass]="{
                'badge-light-success': articleDetails.notification_enabled === 1,
                'badge-light-danger': articleDetails.notification_enabled !== 1
              }"
            >
              {{
                articleDetails.notification_enabled === 1
                  ? ('MENU.DASHBOARD.ENABLED' | translate)
                  : ('MENU.DASHBOARD.DISABLED' | translate)
              }}
            </span>
          </div>

          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.CITY' | translate }}:</strong>
            <span  class="mr-3">{{ articleDetails.city || '-' }}</span>
          </div>

          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.COUNTRY' | translate }}:</strong>
            <span  class="mr-3">{{ articleDetails.country || '-' }}</span>
          </div>

          <div class="col-md-6 mb-2">
            <strong class="me-2">{{ 'MENU.DASHBOARD.UPDATED_AT' | translate }}:</strong>
            <span  class="mr-3">{{ articleDetails.updated_at | date:'mediumDate' }}</span>
          </div>
        </div>

  <!-- Missed Prayers Table -->
<div class="mt-4">
  <h5 class="mb-3">{{ 'MENU.DASHBOARD.MISSED_PRAYERS' | translate }}</h5>
  <div *ngIf="articleDetails.missed_prayers?.length; else noPrayers">
    <table class="table table-bordered table-striped table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>#</th>
          <th>{{ 'MENU.DASHBOARD.MONTHS' | translate }}</th>
          <th>{{ 'MENU.DASHBOARD.TOTAL_DAYS' | translate }}</th>
          <th>{{ 'MENU.DASHBOARD.COMPLETED' | translate }}</th>
          <th>{{ 'MENU.DASHBOARD.PROGRESS' | translate }}</th>
          <th>{{ 'MENU.DASHBOARD.DETAILS' | translate }}</th>
          <th>{{ 'MENU.DASHBOARD.CREATED_AT' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let prayer of articleDetails.missed_prayers; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ prayer.missed_months }}</td>
          <td>{{ prayer.total_days }}</td>
          <td>
            <span
              class="badge"
              [ngClass]="prayer.is_completed ? 'badge-light-success' : 'badge-light-danger'"
            >
              {{ prayer.is_completed ? ('MENU.DASHBOARD.YES' | translate) : ('MENU.DASHBOARD.NO' | translate) }}
            </span>
          </td>

          <!-- Progress -->
          <td>
            <div class="progress-wrapper">
              <div class="progress-info">
                <small>{{ prayer.progress_percent | number:'1.0-1' }}%</small>
              </div>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.width.%]="prayer.progress_percent"
                  [attr.aria-valuenow]="prayer.progress_percent"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  [ngClass]="{
                    'bg-primary': prayer.progress_percent < 50,
                    'bg-warning': prayer.progress_percent >= 50 && prayer.progress_percent < 80,
                    'bg-success': prayer.progress_percent >= 80
                  }"
                ></div>
              </div>
            </div>
          </td>

          <!-- Details -->
          <td>
            <ul class="mb-0 prayer-details">
              <li *ngFor="let d of prayer.details">
                <span class="prayer-name">{{ d.prayer_name }}</span>
                <span class="prayer-count">
                  {{ d.completed_count }}/{{ d.total_count }}
                </span>
              </li>
            </ul>
          </td>

          <td>{{ prayer.created_at | date:'dd MMM yyyy' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noPrayers>
    <p class="text-muted">{{ '-' }}</p>
  </ng-template>
</div>


<!-- Missed Fasting -->
<div class="mt-5 fasting-section">
  <h5 class="mb-3">{{ 'MENU.DASHBOARD.MISSED_FASTING' | translate }}</h5>

  <div *ngIf="articleDetails.missed_fasting?.length; else noFasting">
    <div class="row">

      <div class="col-lg-4 col-md-6 mb-4"
           *ngFor="let fast of articleDetails.missed_fasting">

        <div class="fasting-card">

          <!-- YEAR -->
          <div class="fasting-year">
            <span class="year-label">
              {{ lang === 'ar' ? 'السنة' : 'Year' }}
            </span>

            <span class="year-value">
              {{ fast.year }}
            </span>
          </div>

          <!-- STATUS -->
          <div class="fasting-status"
               [ngClass]="fast.is_completed ? 'completed' : 'pending'">

            <i class="fas"
               [ngClass]="fast.is_completed ? 'fa-check-circle' : 'fa-clock'"></i>

            <span>
              {{
                fast.is_completed
                ? (lang === 'ar' ? 'مكتمل' : 'Completed')
                : (lang === 'ar' ? 'غير مكتمل' : 'Pending')
              }}
            </span>
  
          </div>

          <!-- STATS -->
          <div class="fasting-stats">

            <div class="stat">  
              <span>{{ lang === 'ar' ? 'الإجمالي' : 'Total Days' }}</span>
              <strong>{{ fast.total_days }}</strong>
            </div>

            <div class="stat">
              <span>{{ lang === 'ar' ? 'المتبقي' : 'Remaining' }}</span>
              <strong>{{ fast.remaining_days }}</strong>
            </div>

          </div>

          <!-- REASON -->
          <div class="fasting-reason">
            <span>{{ lang === 'ar' ? 'السبب' : 'Reason' }}</span>
            <p>{{ fast.reason }}</p>
          </div>

          <!-- PROGRESS -->
          <div class="fasting-progress">

            <div class="progress">
              <div
                class="progress-bar"
                [style.width.%]="((fast.total_days - fast.remaining_days) / fast.total_days) * 100"
                [ngClass]="{
                  'bg-primary': ((fast.total_days - fast.remaining_days) / fast.total_days) * 100 < 50,
                  'bg-warning': ((fast.total_days - fast.remaining_days) / fast.total_days) * 100 >= 50 &&
                                ((fast.total_days - fast.remaining_days) / fast.total_days) * 100 < 80,
                  'bg-success': ((fast.total_days - fast.remaining_days) / fast.total_days) * 100 >= 80
                }"
              ></div>
            </div>

            <small>
              {{
                ((fast.total_days - fast.remaining_days) / fast.total_days) * 100
                | number:'1.0-0'
              }}%
            </small>

          </div>

        </div>

      </div>

    </div>
  </div>

  <ng-template #noFasting>
    <p class="text-muted">-</p>
  </ng-template>
</div>
      </div>
    </div>


    
  </div>
</div>
